import { Typography, Button } from "antd";

const { Title, Paragraph } = Typography;

const Dashboard = () => {
  return (
    <div style={{ minHeight: "70vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f6f8fa" }}>
      <div style={{ maxWidth: 400, width: "100%", textAlign: "center" }}>
        <Title level={2}>Área Logada</Title>
        <Paragraph>
          Bem-vindo à sua área logada! Aqui você pode acessar conteúdos exclusivos e gerenciar sua conta.
        </Paragraph>
        <Button type="primary" href="/">
          Voltar para Home
        </Button>
      </div>
    </div>
  );
};

export default Dashboard;